import {
  TimeOffRequestType,
  TIME_OFF_TYPE_ALTERNATE_LABELS,
} from '../constants/TimeOffTypes'

// Re-export enums for backward compatibility
export { TimeOffRequestType, TimeOffDuration } from '../constants/TimeOffTypes'

/**
 * Get time off type label from code
 * E.g., "V" -> "Vacation", "F" -> "Float Day"
 */
export const getTimeOffTypeLabel = (code: string): string => {
  const typeCode = code?.toUpperCase() as keyof typeof TimeOffRequestType
  return TimeOffRequestType[typeCode] || code
}

/**
 * Get detailed time off type label for request details display.
 * Handles regular types (V, F, D, B, A, O) and Other subtypes.
 * E.g., "V" -> "Vacation (PTO/ETO)", "OTH_JD" with subtype -> "Other - Jury Duty"
 */
export const getRequestDetailsTypeLabel = (
  typeCode: string,
  subTypeCode?: string | null
): string => {
  if (typeCode === 'O' && subTypeCode) {
    const otherLabels: Record<string, string> = {
      OTH_JD: 'Other - Jury Duty',
      OTH_UB: 'Other - Union Business',
      OTH_BL: 'Other - Bereavement Leave',
      OTH_TM: 'Other - Training/Meeting',
      OTH_ET: 'Other - Education Time',
      OTH_DA: 'Other - Doctors Appointment',
      OTH_UT: 'Other - Unpaid Time',
      OTH_LT: 'Other - Labor Management Partnership Time',
      OTH_PT: 'Partnership Time',
    }
    return otherLabels[subTypeCode] || `Other - ${subTypeCode}`
  }

  const customLabels: Record<string, string> = {
    V: 'Vacation (PTO/ETO)',
    F: 'Float',
    D: 'Flexible Personal Days',
    B: 'Birthday',
    A: 'Vacation Bidding',
    O: 'Other',
    M: 'Multiple',
  }
  return customLabels[typeCode] || typeCode || 'N/A'
}

/**
 * Get time off type code from label
 * E.g., "Vacation" -> "V", "Float Day" -> "F"
 * Also handles alternate labels: "FLOAT" -> "F", "FPD" -> "D", "OTHER" -> "O"
 */
export const getTimeOffTypeCode = (label: string): string | undefined => {
  // Check direct match in enum values
  for (const [code, enumLabel] of Object.entries(TimeOffRequestType)) {
    if (enumLabel.toLowerCase() === label.toLowerCase()) {
      return code
    }
  }
  // Handle alternate labels used in filter UI
  return TIME_OFF_TYPE_ALTERNATE_LABELS[label.toUpperCase()]
}

export const mapAllocationTypeLabel = (typeLabel: string, hours: number) => {
  return {
    typeLabel: getTimeOffTypeLabel(typeLabel),
    hours,
  }
}
